import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import useStyles from './style'
import { Box, Button, Dialog, Divider, Drawer, IconButton, InputAdornment, MenuItem, Paper, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from '@material-ui/core'
import closeIcon from '@assets/icons/payment/close.svg'
import { Controller, useForm } from 'react-hook-form';
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import clsx from 'clsx'
// import helper from 'utils/helper'
import fetch from '@utils/fetch'
import helper from '@utils/helper'
import { USD } from '@constants/common'

const RegisterPackage = ({ 
  open, 
  onClose, 
  id,
  toggleDrawer
}) => {
    const [error,setError] = useState(null)
    const classes = useStyles()
    const [method,setMethod] = useState('register')
    const [currency,setCurrency] = useState('VND')
    const schema = yup.object().shape(
        {
            price: yup
                .number()
                .typeError('Vui lòng nhập số')
                .min(1,"Vui lòng nhập giá tiền cao hơn 1")
                .required("Vui lòng nhập giá tiền"),
            dynamicQty: yup
                .number()
                .typeError('Vui lòng nhập số')
                .integer("Vui lòng nhập số nguyên")
                .min(1,"Vui lòng nhập số lượng code động cao hơn 0")
                .required("Vui lòng nhập số lượng code động"),
            staticQty: yup
                .number()
                .typeError('Vui lòng nhập số')
                .integer("Vui lòng nhập số nguyên")
                .min(1,"Vui lòng nhập số lượng code tĩnh cao hơn 0")
                .required("Vui lòng nhập số lượng code tĩnh"),
            tokens: yup
                .number()
                .typeError('Vui lòng nhập số')
                .integer("Vui lòng nhập số nguyên")
                .min(1,"Vui lòng nhập số lượng tokens cao hơn 0")
                .required("Vui lòng nhập số lượng tokens"),
            useTime: yup
                .number()
                .typeError('Vui lòng nhập số')
                .integer("Vui lòng nhập số nguyên")
                .min(1,"Vui lòng nhập thời hạn sử dụng cao hơn 0")
                .required("Vui lòng nhập thời hạn sử dụng"),
            content: yup.string().required("Vui lòng nhập nội dung"),
        }
    );
    const { register, handleSubmit, reset, setValue, watch, getValues, control, formState: { errors, isDirty, dirtyFields } } = useForm({
        mode: "onChange",
        defaultValues: {
          price: 1,
          dynamicQty: 1,
          staticQty: 1,
          useTime: 1,
          content: "",
          tokens: 1
        },
        resolver: yupResolver(schema),
        shouldUnregister: false,
    })
    const [dialogCancel,setDialogCancel] = useState(false)
    const [customPackage, setCustomPackage] = useState()
    const onSubmit = async (values) => {
        setDialogCancel(true)
        setCustomPackage(values)
    }
    const handleClose = ()=>{
        setDialogCancel(false)
    }
    const handleConfirm =()=>{
        customPackage.id = id
        customPackage.method = method
        customPackage.currency = currency
        if(method==='payment'){
            delete customPackage.staticQty
            delete customPackage.dynamicQty
            delete customPackage.useTime
        }
        fetch('/api/billing/subscriptions/register-plan', {
            body: JSON.stringify(customPackage),
            // secure: true,
            method: 'PATCH',
            headers: { 'x-role-context': 'admin', 'Content-Type': 'application/json', 'Authorization': `Bearer ${localStorage.getItem("sid")}` },
          })
            .then(({ status, body }) => {
              // dispatch(stream(true))
              if (status >= 400) {
                console.log("error register plan status",body)
                setError(body?.message)
              }
              else{
                if(body?.result?.payUrl){
                    window.open(body?.result?.payUrl, '_blank', 'noopener,noreferrer');
                }
                toggleDrawer(false)
                setError(null);
                window.location.reload();
              }
            })
            .catch((err) => {
                console.log("error register plan",err)})
    }
    return (
      <Drawer
        anchor="right"
        open={open}
        onClose={onClose}
        classes={{ paper: classes.drawPaper }}
      >
        <Box role="presentation">
          <Typography className={classes.drawTitle}>
            Đăng ký gói custom
            <IconButton className={classes.drawIconClose} onClick={onClose}>
              <img src={closeIcon} alt="closeIcon" />
            </IconButton>
          </Typography>
          <Divider />
          {
            error && <p className={classes.textError}>{error}</p>
          }
          <Select
            style={{width:"100%", marginTop:"20px"}}
            value={method}
            onChange={(e)=>setMethod(e?.target?.value || 'register')}
          >
            <MenuItem value='register'>Đăng Ký gói</MenuItem>
            <MenuItem value='payment'>Nạp tiền</MenuItem>
          </Select>
          <form className="box-event" onSubmit={handleSubmit(onSubmit)}>
            <Grid container spacing={2} className={classes.wrapfiled}>
                <Grid item xs={12}>
                    <Controller
                        name="price"
                        control={control}
                        render={({ onChange, onBlur, value }) => (
                        <TextField
                            {...register("price")}
                            placeholder="Giá tiền"
                            label="Giá tiền"
                            InputProps={{
                                endAdornment:(<InputAdornment position="end">
                                    <Select
                                        value={currency}
                                        onChange={(e)=>setCurrency(e?.target?.value || 'VND')}
                                    >
                                        <MenuItem value='VND'>VND</MenuItem>
                                        <MenuItem value='USD'>USD</MenuItem>
                                    </Select>
                                </InputAdornment>),
                                inputProps: { min: 1 }
                            }}
                            type='text'
                            onChange={(e)=>setValue("price",(e.target.value))}
                            onBlur={onBlur}
                            value={value}
                            fullWidth
                            error={Boolean(errors?.price)}
                            helperText={errors?.price?.message}
                            variant="standard"
                        />
                        )}
                    />
                </Grid>
                {
                    (method === 'register') && <>
                        <Grid item xs={12}>
                            <Controller
                                name='dynamicQty'
                                control={control}
                                render={({ onChange, onBlur, value }) => (
                                <TextField
                                    {...register("dynamicQty")}
                                    placeholder="Số lượng code động"
                                    label="Số lượng code động"
                                    type='number'
                                    InputProps={{
                                        inputProps: { min: 1 }
                                    }}
                                    onChange={(e)=>setValue("dynamicQty",(e.target.value))}
                                    onBlur={onBlur}
                                    value={value}
                                    fullWidth
                                    error={Boolean(errors?.dynamicQty)}
                                    helperText={errors?.dynamicQty?.message}
                                    variant="standard"
                                />
                                )}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Controller
                                name='staticQty'
                                control={control}
                                render={({ onChange, onBlur, value }) => (
                                <TextField
                                    {...register("staticQty")}
                                    placeholder="Số lượng code tĩnh"
                                    label="Số lượng code tĩnh"
                                    type='number'
                                    InputProps={{
                                        inputProps: { min: 1 }
                                    }}
                                    onChange={(e)=>setValue("staticQty",(e.target.value))}
                                    onBlur={onBlur}
                                    value={value}
                                    fullWidth
                                    error={Boolean(errors?.staticQty)}
                                    helperText={errors?.staticQty?.message}
                                    variant="standard"
                                />
                                )}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Controller
                                name='useTime'
                                control={control}
                                render={({ onChange, onBlur, value }) => (
                                <TextField
                                    {...register("useTime")}
                                    placeholder="Thời hạn sử dụng"
                                    label="Thời hạn sử dụng"
                                    InputProps={{
                                        endAdornment:(<InputAdornment position="end">/Tháng</InputAdornment>),
                                        inputProps: { min: 1 }
                                    }}
                                    type='number'
                                    onChange={(e)=>setValue("useTime",(e.target.value))}
                                    onBlur={onBlur}
                                    value={value}
                                    fullWidth
                                    error={Boolean(errors?.useTime)}
                                    helperText={errors?.useTime?.message}
                                    variant="standard"
                                />
                                )}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Controller
                                name='tokens'
                                control={control}
                                render={({ onChange, onBlur, value }) => (
                                <TextField
                                    {...register("tokens")}
                                    placeholder="Số lượng tokens"
                                    label="Số lượng tokens"
                                    InputProps={{
                                        endAdornment:(<InputAdornment position="end">Nghìn Tokens</InputAdornment>),
                                        inputProps: { min: 1 }
                                    }}
                                    type='number'
                                    onChange={(e)=>setValue("tokens",(e.target.value))}
                                    onBlur={onBlur}
                                    value={value}
                                    fullWidth
                                    error={Boolean(errors?.tokens)}
                                    helperText={errors?.tokens?.message}
                                    variant="standard"
                                />
                                )}
                            />
                        </Grid>
                    </>
                }
                <Grid item xs={12}>
                    <Controller
                        name='content'
                        control={control}
                        render={({ onChange, onBlur, value }) => (
                        <TextField
                            {...register("content")}
                            placeholder="Nội dung"
                            label="Nội dung"
                            type='text'
                            multiline
                            maxRows={10}
                            onChange={(e)=>setValue("content",(e.target.value))}
                            onBlur={onBlur}
                            value={value}
                            fullWidth
                            error={Boolean(errors?.content)}
                            helperText={errors?.content?.message}
                            variant="outlined"
                        />
                        )}
                    />
                </Grid>
            </Grid>
            <div className={classes.btnRegister}>
                <Button
                    className={clsx(classes.statusBtnAccept,classes.statusBtn)}
                    // color={"primary"}
                    variant="outlined"
                    type='submit'
                >
                    Đăng ký
                </Button>
            </div>
          </form>
        </Box>
        <Dialog open={dialogCancel} onClose={handleClose} className={classes.dialogContent}>

        <Box sx={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', alignItems: 'center' ,padding: '34px 43px', width: '423px' }}>
                <Box sx={{ fontSize: '20px', fontWeight: '500', color: '#000000'}}>
                    Xác nhận đăng ký gói custom
                </Box>
                <Box sx={{ color:'#41B60B', padding: '12px 0px', width:"100%",display:'flex', justifyContent:'center' }}>
                    <h3>
                        {
                            currency==="VND"
                            ? helper.formatCash.format(customPackage?.price)
                            : helper.formatCashLanguage("USD",customPackage?.price*USD)
                        }
                    </h3>
                </Box>
                <Box sx={{ display: 'flex', marginTop: '12px', justifyContent: 'space-between', width: '100%',
                    '& .MuiButton-root': {
                        padding: '5px 30px',
                        width: '48%'
                    }
                }}>
                    <Button onClick={handleClose} variant='contained'style={{background:"#E0E0E0", color:"black"}}> Huỷ</Button>
                    <Button
                        style={{background:"#41B60B", color:"white"}}
                        variant="contained"
                        onClick={handleConfirm}
                    > Xác nhận
                    </Button>
                </Box>
            </Box>
            </Dialog>
      </Drawer>
    );
}

export default RegisterPackage
